import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/relatorio/movimentacaoAnimal' };
/////////////////////////////////////////////////////////////////////////////////

export function getLancamentosLista(idPropriedade, idAnoPecuario, datas) {
  return httpService.get({ ...args, args: `/lista?propriedade=${idPropriedade}&datas=${datas}&anoPecuario=${idAnoPecuario}` });
}
